// Resize + auto-format Cloudinary images; other URLs are returned unchanged.
export function cdn(url, width) {
  if (!url || !url.includes("res.cloudinary.com") || !url.includes("/upload/")) return url;
  if (/\/upload\/[a-z]_[^/]*,/.test(url) || /\/upload\/(f|q|w|c)_/.test(url)) return url;
  return url.replace("/upload/", `/upload/f_auto,q_auto,c_limit,w_${width}/`);
}
